import { render, staticRenderFns } from "./task.vue?vue&type=template&id=74d9c2d7&scoped=true&"
import script from "./task.vue?vue&type=script&lang=ts&"
export * from "./task.vue?vue&type=script&lang=ts&"
import style0 from "./task.vue?vue&type=style&index=0&id=74d9c2d7&lang=less&scoped=true&"
import style1 from "./task.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74d9c2d7",
  null
  
)

export default component.exports